var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "shareModal",
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "shareModalLabel",
        "aria-hidden": "true",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-dialog-centered",
          attrs: { role: "document" },
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _vm.isGeneratingShareLink
                ? _c("div", { staticClass: "text-center" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c("p", { staticClass: "mt-2" }, [
                      _vm._v(
                        "\n            Generating share link...\n          "
                      ),
                    ]),
                  ])
                : _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "share-link" } }, [
                      _vm._v("Share Link"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.shareLink,
                            expression: "shareLink",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { id: "share-link", type: "text", readonly: "" },
                        domProps: { value: _vm.shareLink },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.shareLink = $event.target.value
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-group-append" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-secondary",
                            attrs: { type: "button" },
                            on: { click: _vm.copyShareLink },
                          },
                          [_c("i", { staticClass: "fas fa-copy" })]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "btn btn-outline-secondary",
                            attrs: { href: _vm.shareLink, target: "_blank" },
                          },
                          [_c("i", { staticClass: "fas fa-external-link-alt" })]
                        ),
                      ]),
                    ]),
                  ]),
            ]),
            _vm._v(" "),
            _vm._m(2),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "h5",
        { staticClass: "modal-title", attrs: { id: "shareModalLabel" } },
        [_vm._v("\n          Share Preview\n        ")]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close",
          },
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass: "spinner-border spinner-border-sm",
        attrs: { role: "status" },
      },
      [_c("span", { staticClass: "sr-only" }, [_vm._v("Loading...")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-footer" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-secondary",
          attrs: { type: "button", "data-dismiss": "modal" },
        },
        [_vm._v("\n          Close\n        ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }